import { STORES } from '../types'
import { useLocation } from '../contexts/LocationContext'

interface StoreSelectorProps {
  selectedStore: string
  onStoreChange: (store: string) => void
  className?: string
}

const StoreSelector = ({ selectedStore, onStoreChange, className = '' }: StoreSelectorProps) => {
  const { currentStore } = useLocation()
  
  // If user is not in a store, show "Kaikki kaupat", otherwise show current store context
  const getDisplayText = (store: string) => {
    if (store === 'all') {
      return currentStore ? `Kaikki (nyt: ${currentStore})` : 'Kaikki kaupat'
    }
    return store
  }

  return (
    <div className={`inline-flex items-center space-x-2 ${className}`}>
      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
      <span className="text-sm font-medium text-gray-700">Näyttö:</span>
      <select
        value={selectedStore}
        onChange={(e) => onStoreChange(e.target.value)}
        className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 bg-white"
      >
        {STORES.map(store => (
          <option key={store} value={store}>
            {getDisplayText(store)}
          </option>
        ))}
      </select>
    </div>
  )
}

export default StoreSelector 